import ApiClient from './ApiClient';

class ClassificationsAPI extends ApiClient {
  constructor() {
    super('classifications', { accountScoped: true });
  }
}

export default new ClassificationsAPI();
